import { useEffect, useCallback } from "react";

import { useStateRef } from "../hooks/customHooks";
const useWindowOffset = () => {
  const [, setWindowOffset, windowOffsetRef] = useStateRef(0);

  const computeAndSetOffset = useCallback(() => {
    const offset =
      window.innerWidth > 1440 ? (window.innerWidth - 1440) / 2 + 24 : 20;
    setWindowOffset(offset);
  }, [setWindowOffset]);

  useEffect(() => {
    window.addEventListener("resize", computeAndSetOffset);
    return () => {
      window.removeEventListener("resize", computeAndSetOffset);
    };
  }, [computeAndSetOffset]);

  return [computeAndSetOffset, windowOffsetRef];
};

export { useWindowOffset };
